import { createContext, useContext } from "react";

// Define the PermissionContext
export const PermissionContext = createContext<string[]>([]);

// Custom hook to access permissions from the context
export const usePermissions = () => useContext(PermissionContext);
